'use client';

import { Box, Grid, GridItem, Typography } from '@coolblue-development/freddy';
import { SelectableBox, SelectableBoxGroup } from '@coolblue-development/next-patterns/client';
import { ExplanationLink } from '@features/product/components/ProductTradeIn/Modal/ConditionSelector/ExplanationLink';
import { useTranslation } from '@i18n/useTranslation';
import { Fragment, useContext } from 'react';

import { ProductTradeInContext } from '../Context';
import { Actions, type Answer, type Question } from '../types';
import Summary from './Summary';

const ConditionSelector = () => {
  const { t } = useTranslation('webshop.productTradeIn');
  const { answers, dispatch, handleAnswerChange, questions } = useContext(ProductTradeInContext);

  function handleOnChange(question: Question, answer: Answer) {
    dispatch?.({
      type: Actions.SET_ANSWER,
      payload: { questionId: question.questionId, answer }
    });

    handleAnswerChange?.(question, answer);
  }

  return (
    <Grid gap={{ xs: 0, md: 600 }} templateColumns={{ xs: '1fr', md: '6fr 3.5fr' }}>
      <Box sx={{ overflowY: 'auto' }}>
        {questions?.map(question => (
          <Fragment key={question.questionId}>
            <Typography variant='h3' mt={600}>
              {question.question}{' '}
              {question.explanation?.trim() && (
                <ExplanationLink explanation={question.explanation} title={question.question} />
              )}
            </Typography>

            <SelectableBoxGroup
              name={`ConditionSelectorGroup-${question.questionId}`}
              type='radio'
              spacing='compact'
              inputPlacement='hidden'
              value={answers?.[question.questionId] || ''}
              onChange={value => handleOnChange(question, value)}
            >
              <Grid gap={200} mt={200}>
                <GridItem column={{ xs: 'span 6', md: 'span 3' }} sx={{ textAlign: 'center' }}>
                  <SelectableBox value='yes'>
                    <Box py={{ xs: 200, md: 0 }}>{t('answers.yes')}</Box>
                  </SelectableBox>
                </GridItem>
                <GridItem column={{ xs: 'span 6', md: 'span 3' }} sx={{ textAlign: 'center' }}>
                  <SelectableBox value='no'>
                    <Box py={{ xs: 200, md: 0 }}>{t('answers.no')}</Box>
                  </SelectableBox>
                </GridItem>
              </Grid>
            </SelectableBoxGroup>
          </Fragment>
        ))}
      </Box>
      <Summary />
    </Grid>
  );
};

export default ConditionSelector;
